import React, { createRef, useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { validarSubmit } from '../../../../../../Services/Validation/HelperValidation';
import InputValidation from '../../../../../../Services/Validation/InputValidation';
import {registro_sera_actualizado, servicios_grupogack_catalogo} from '../../../../../../Constants/Constants';
import Alertwarning from '../../../../../../Services/Alerts/AlertWarning';
import SelectValidation from '../../../../../../Services/Validation/SelectValidation';
import { headersAuth } from '../../../../../../Services/AuthService';
import Axios from 'axios';

const FormContratosRelLab = ({ error, setError, enviarContratosRelLab, elementSelect, actualizarContratosRelLab }) => {

    const nombreRef = createRef('');
    const [alertWarning, setAlertWarning]=useState(false);
    const relLaboralRef = createRef('');
    const tipoContratolRef = createRef(''); 
    const [ tiposContrato, setTiposContrato ] = useState( null );
    const [relacionLaboral, setCompania] = useState(null);
    const [fecha, setFecha]=useState(elementSelect ? elementSelect.contratoSaoFechas==='Sí' :false );
    useEffect(() => {
        Axios.get(`${servicios_grupogack_catalogo}/relacionlaboral/`, headersAuth())
        .then(res => {
            switch(res.data.status) {
                case 200: 
                        setCompania(res.data.dataResponse);
                    break;
                case 404:
                    setCompania([]);
                    break;
                default:
                    alert('error');
                    break;
            }
        })
        .catch(error => alert('error'));

        Axios.get( `${servicios_grupogack_catalogo}/contrato/`, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:
                        setTiposContrato( respuesta.data.dataResponse );
                        break;
                    case 404:
                        setTiposContrato([]);
                        break;
                    default:
                        break;
                }
            })
            .catch( error => { console.log( error ) });
            // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const enviar = e => {
        e.preventDefault();
        if(validarSubmit('AgregarContratosRelLab')) {
            const contratoSaoNom = nombreRef.current.value;
            const tipoContrato = parseInt(tipoContratolRef.current.value);
            const relacionLaboral = parseInt(relLaboralRef.current.value); 
            const contratoSaoFechas = fecha==='true';
            enviarContratosRelLab({ contratoSaoNom, tipoContrato, relacionLaboral, contratoSaoFechas });
        }
    };

    const actualizar =()=> {
        if(validarSubmit('EditarContratosRelLab')) {
            const contratoSaoNom = nombreRef.current.value;
            const tipoContrato = parseInt(tipoContratolRef.current.value);
            const relacionLaboral = parseInt(relLaboralRef.current.value); 
            const contratoSaoFechas = fecha==='true';
            setError(null);
            actualizarContratosRelLab({ contratoSaoNom, tipoContrato, relacionLaboral, contratoSaoFechas }, elementSelect.id);
            setAlertWarning(false);
        }
    };
    const alert = e =>{
        e.preventDefault();
        setAlertWarning(true);
    };
    
    return (  
        <form id={ elementSelect ? 'EditarContratosRelLab' : 'AgregarContratosRelLab' } onSubmit={ elementSelect ? alert : enviar }>
           <div className="row">
                <div className="col-md-12 col-sm-12">
                    <InputValidation title="Nombre del Contrato" type="nombreContrato" placeholder="Escriba el nombre del Contrato"
                        tooltipText={`Máximo 100 letras, números, espacios y/o signos de puntuación . , - ( ) " ' #`} tooltipName={'tooltipNomContratoRelLab'} maxLength={100}
                        refValue={nombreRef} defaultValue={ elementSelect ? elementSelect.contratoSaoNom : '' } required/>
                </div>
            </div>
 
            <div className="row">
                <div className="col-md-6 col-sm-12">
                    {   
                        tiposContrato
                        ?
                        <SelectValidation title="Tipo de Contrato" arrayOpciones={tiposContrato} refValue={tipoContratolRef} keyOpcion="tipoContratoDesc" 
                        defaultValue={ elementSelect ? elementSelect.tipoContratoId : ''} required/> 
                        :null
                    } 
                </div>
                <div className="col-md-6 col-sm-12">
                    {   
                        relacionLaboral
                        ?
                        <SelectValidation title="Tipo de Relación Laboral" arrayOpciones={relacionLaboral} refValue={relLaboralRef} keyOpcion="nombre" 
                        defaultValue={ elementSelect ? elementSelect.relacionLaboralId : ''} required/>
                        :null
                    } 
                </div>
            </div>
            <div className="row">
                <div className="col-md-3 col-sm-12 form-group">
                    <label className="form-check-label">Fechas:</label>
                </div>
                <div className="col-md-9 col-sm-12 form-group">
                    <div className="form-check form-check-inline">
                        <label className="labelRadio">Sí
                            <input type="radio"  name="fecha" required value={true} onChange={e=>{setFecha(e.target.value)}} 
                                defaultChecked={ elementSelect ? elementSelect.contratoSaoFechas==='Sí' :false } />
                            <span className="spanRadio"></span>
                        </label>
                    </div>
                    <div className="form-check form-check-inline">
                        <label className="labelRadio">No
                            <input type="radio"  name="fecha" value={false} onChange={e=>{setFecha(e.target.value)}}
                                defaultChecked={ elementSelect ? elementSelect.contratoSaoFechas==='No' :true }/>
                            <span className="spanRadio"></span>
                        </label>
                    </div>
                </div>
            </div>
            <Button variant="contained" className="btn-color" type="submit">{ elementSelect ? 'Actualizar' : 'Agregar' }</Button>
            <Alertwarning show={alertWarning} SetopenALert={setAlertWarning} text={registro_sera_actualizado} textButtonAceptar="Aceptar" textButtonCancelar="Cancelar" action={actualizar} />
        </form>    
    );
}

export default FormContratosRelLab;